import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { AlertContext } from "../../../context/AlertContext";
import Spinner from "../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import ButtonMui from "@mui/material/Button";
import { Navigate, useNavigate } from "react-router-dom";
import Menu from "../Menu";
import { saveAs } from "file-saver";
import Autocomplete from "@mui/material/Autocomplete";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { jsPDF } from "jspdf";
import { MultiSelect } from "primereact/multiselect";

export default function ListadoBancos(props) {
  const exportColumns = [
    { title: "Fecha", dataKey: "fecha" },
    { title: "Nro.", dataKey: "id" },
    { title: "Cuenta", dataKey: "cuenta" },
    { title: "Concepto", dataKey: "concepto" },
    { title: "Detalle", dataKey: "detalle" },
    { title: "Rend/Orden", dataKey: "rendicionOrden" },
    { title: "Ingresos", dataKey: "ingresos" },
    { title: "Egresos", dataKey: "egresos" },
    { title: "Saldo", dataKey: "saldo" },
  ];

  const exportColumnsTransferencias = [
    { title: "Fecha", dataKey: "fecha" },
    { title: "Empresa Origen.", dataKey: "empresaOrigen" },
    { title: "Banco Origen.", dataKey: "bancoOrigen" },
    { title: "Importe Origen.", dataKey: "importeOrigen" },
    { title: "Empresa Destino.", dataKey: "empresaDestino" },
    { title: "Banco Destino.", dataKey: "bancoDestino" },
    { title: "Importe Destino.", dataKey: "importeDestino" },
    { title: "Detalle", dataKey: "detalle" },
  ];

  const [listado, setListado] = useState({
    orientacion: "vertical",
    camposSeleccionados: [],
  });
  const [visible, setVisible] = useState(true);
  const toast = useRef(null);
  const [selectedCities, setSelectedCities] = useState([]);
  const [bandInicio, setBandInicio] = useState(false);
  const [exportListado, guardarExportListado] = useState(null);
  const [moneda, guardarMoneda] = useState(null);
  const [soloTransferencias, setSoloTransferencias] = useState(false);
  const [excluirTransferencias, setExcluirTransferencias] = useState(false);
  const cuentaBanco = useRef();
  const [cuentaTodas, setCuentaTodas] = useState(false);
  const [cuenta, guardarCuenta] = useState([]);

  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    monedas,
    empresas,
    cuentas,
    empresaElegida,
    movimientosBancos,
    BancosEgresos,
    BancosIngresos,
    BancosSaldoAnterior,
    BancosSaldoActual,
    monedaPredeterminada,
    obtenerAcceso,
    obtenerListadoBancos,
    obtenerMonedas,
    obtenerCuentas,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ListadosBancos",
      });
    }
  }, [state]);

  useEffect(() => {
    obtenerCuentas();
    obtenerMonedas();
    if (monedas && monedaPredeterminada) {
      let mon = monedas.findIndex((item) => item.id === monedaPredeterminada);
      guardarMoneda({
        id_moneda: monedaPredeterminada,
        moneda: monedas[mon].nombre,
      });
    }
  }, [monedas.id_moneda, monedaPredeterminada]);

  const exitClick = (e) => {
    navigate("/");
  };

  const onHide = (e) => {
    setVisible(false);
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Listado de Bancos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const aceptarClick = async (exportType) => {
    //e.preventDefault();
    // Validar|

    if (
      !listado ||
      listado.fechaDesde === undefined ||
      listado.fechaDesde === null ||
      listado.fechaDesde === null ||
      listado.fechaDesde === ""
    ) {
      mensajeAlerta(
        "Listados de Bancos",
        "Debe indicar fecha desde !.",
        "error"
      );
      return;
    }

    if (
      !listado ||
      listado.fechaHasta === undefined ||
      listado.fechaHasta === null ||
      listado.fechaHasta === null ||
      listado.fechaHasta === ""
    ) {
      mensajeAlerta(
        "Listados de Bancos",
        "Debe indicar fecha hasta !.",
        "error"
      );
      return;
    }

    if (listado.fechaDesde > listado.fechaHasta) {
      mensajeAlerta(
        "Listados de Bancos",
        "Fecha desde no puede ser mayor que fecha hasta !.",
        "error"
      );
      return;
    }

    if (!cuentaTodas && !cuenta) {
      mensajeAlerta(
        "Listados de Bancos",
        "Debe seleccionar cuenta de banco !.",
        "error"
      );
      return;
    }

    if (soloTransferencias && excluirTransferencias) {
      mensajeAlerta(
        "Listados de Bancos",
        "No pueden estar las dos opciones marcadas !.",
        "error"
      );
      return;
    }

    if (selectedCities && selectedCities.length === 0) {
      mensajeAlerta(
        "Listados de Bancos",
        "Debe indicar una empresa !.",
        "error"
      );
      return;
    }

    var elem;

    await obtenerListadoBancos({
      desde: listado.fechaDesde,
      hasta: listado.fechaHasta,
      empresasSeleccionadas: selectedCities,
      moneda,
      soloTransferencias,
      excluirTransferencias,
      cuenta,
      cuentaTodas,
    }).then((data) => {
      if (exportType === "excel") {
        elem = document.getElementById("expButtonExcel");
        elem.click();
      }
      if (exportType === "pdf") {
        elem = document.getElementById("expButtonPdf");
        elem.click();
      }
    });
    onHide();
    //exitClick();
  };

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Listado de Bancos"></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <button
          id="expButtonExcel"
          type="button"
          onClick={(e) => {
            exportExcel();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Excel
        </button>
        <button
          id="expButtonPdf"
          type="button"
          onClick={(e) => {
            exportPdf();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Pdf
        </button>
        <Button
          icon="pi pi-file-excel"
          onClick={(e) => {
            aceptarClick("excel");
          }}
          className="p-button-raised p-button-success"
          data-pr-tooltip="XLS"
          label="Excel"
        />
        <Button
          icon="pi pi-file-pdf"
          onClick={(e) => {
            aceptarClick("pdf");
          }}
          className="p-button-raised p-button-warning"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
          label="PDF"
        />
        {/*
        <ButtonMui
          onClick={aceptarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        */}
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const exportExcel = () => {
    for (let i = 0; i < movimientosBancos.length; i++) {
      if (movimientosBancos[i].ingresos) {
        movimientosBancos[i].ingresos = movimientosBancos[
          i
        ].ingresos.replaceAll(",", "");
        movimientosBancos[i].egresos = movimientosBancos[i].egresos.replaceAll(
          ",",
          ""
        );
        movimientosBancos[i].saldo = movimientosBancos[i].saldo.replaceAll(
          ",",
          ""
        );
        movimientosBancos[i].ingresos = parseFloat(
          movimientosBancos[i].ingresos,
          10
        );
        movimientosBancos[i].egresos = parseFloat(
          movimientosBancos[i].egresos,
          10
        );
        movimientosBancos[i].saldo = parseFloat(movimientosBancos[i].saldo, 10);
      }
    }
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(movimientosBancos);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "bancos");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName +
            "_export_" +
            new Date().toLocaleDateString() +
            EXCEL_EXTENSION
        );
        resolve(true);
      });
    });
    startClick();
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default('l');
        doc.setFontSize(12);
        if (soloTransferencias) {
          doc.text(
            "Listado de transferencias entre cuentas Desde " +
              formatDate(listado.fechaDesde) +
              " Hasta " +
              formatDate(listado.fechaHasta),
            30,
            8
          );
        } else {
          doc.text(
            "Listado de movimientos de bancos Desde " +
              formatDate(listado.fechaDesde) +
              " Hasta " +
              formatDate(listado.fechaHasta),
            30,
            8
          );
        }
        let empresas = "";
        for (let i = 0; i < selectedCities.length; i++) {
          if (i === 0) {
            empresas = selectedCities[i].nombre;
          } else {
            empresas = empresas + " - " + selectedCities[i].nombre;
          }
        }

        doc.setFontSize(7);
        doc.text(`Empresas: ${empresas}`, 5, 13);

        if (soloTransferencias) {
          doc.autoTable(exportColumnsTransferencias, movimientosBancos, {
            styles: {
              fontSize: 7,
            },

            columnStyles: {
              5: {
                halign: "right",
              },
              6: {
                halign: "right",
              },
              7: {
                halign: "right",
              },
            },
            didParseCell: (data) => {
              if (data.cell && data.cell.section === "head") {
                switch (data.cell.raw) {
                  case "Ingresos":
                  case "Egresos":
                  case "Saldo":
                    data.cell.styles.halign = "right";
                    break;
                  default:
                    data.cell.styles.halign = "left";
                    break;
                }
              }
            },
          });
        } else {
          doc.autoTable(exportColumns, movimientosBancos, {
            styles: {
              fontSize: 7,
            },

            columnStyles: {
              5: {
                halign: "right",
              },
              6: {
                halign: "right",
              },
              7: {
                halign: "right",
              },
              8: {
                halign: "right",
              },
            },
            didParseCell: (data) => {
              if (data.cell && data.cell.section === "head") {
                switch (data.cell.raw) {
                  case "Ingresos":
                  case "Egresos":
                  case "Saldo":
                    data.cell.styles.halign = "right";
                    break;
                  default:
                    data.cell.styles.halign = "left";
                    break;
                }
              }
            },
          });
        }
        window.open(doc.output("bloburl"));
        //doc.save("residentes_caidas_" + new Date().toLocaleDateString() +".pdf");
      });
    });
    startClick();
  };

  const startClick = (e) => {
    setTimeout(() => {
      //navigate("listadosservicios");
      setVisible(true);
    }, 2000);
  };

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  // INICIO

  if (!bandInicio && empresas && empresas.length > 0 && empresaElegida) {
    setBandInicio(true);
    const index = empresas.findIndex((item) => item.id === empresaElegida.id);
    if (index !== -1) {
      let final = [];
      final.push(empresas[index]);
      setSelectedCities(final);
    }
  }

  // FIN

  //console.log(cuentas);
  //console.log(cuenta);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Dialog
            header={renderHeader()}
            visible={visible}
            closable={false}
            footer={renderFooter()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "75vw", paddingBottom: "0" }}
            position="center"
          >
            <Grid container spacing={3} style={{ marginTop: "0vw" }}>
              <Grid item xs={12} md={2}>
                <TextField
                  id="fechaDesde"
                  label="Fecha Desde"
                  type="date"
                  variant="standard"
                  fullWidth
                  value={listado ? listado.fechaDesde : null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setListado({
                      ...listado,
                      fechaDesde: e.target.value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  id="fechaHasta"
                  label="Fecha Hasta"
                  type="date"
                  variant="standard"
                  fullWidth
                  value={listado ? listado.fechaHasta : null}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setListado({
                      ...listado,
                      fechaHasta: e.target.value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Autocomplete
                  id="cuenta"
                  ref={cuentaBanco}
                  fullWidth
                  required
                  noOptionsText={"No hay opciones"}
                  value ={cuentas[
                          cuentas.findIndex((item) => item.id === cuenta.id_cuenta)
                        ]}
                  options={
                    cuentas && cuenta && cuenta.length>0
                      ? cuentas[
                          cuentas.findIndex((item) => item.id === cuenta.id_cuenta)
                        ]
                      : cuentas
                      ? cuentas.filter((item) => item.habilitado)
                      : null
                  }
                  getOptionLabel={(option) => option.nombre}
                  openOnFocus={true}
                  disablePortal
                  style={{ marginTop: "-0.3vw", marginLeft: "2vw" }}
                  disabled={cuentaTodas}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Cuenta *"
                      variant="standard"
                    />
                  )}
                  onChange={(event, value) => {
                    if (value) {
                      guardarCuenta({
                        id_cuenta: value.id,
                        cuenta: value.nombre,
                      });
                    } else {
                      guardarCuenta({
                        id_cuenta: null,
                        cuenta: null,
                      });
                    }
                  }}
                />
              </Grid>

              <FormControlLabel
                value="yes"
                control={
                  <Checkbox
                    color="primary"
                    checked={cuentaTodas}
                    style={{ marginLeft: "1vw" }}
                    onChange={(e) => {
                      setCuentaTodas(e.target.checked);
                      const ele = cuentaBanco.current.getElementsByClassName(
                        "MuiAutocomplete-clearIndicator"
                      )[0];
                      if (ele) ele.click();
                    }}
                  />
                }
                label="Todas las cuentas"
                labelPlacement="start"
                style={{ paddingLeft: "2vw", paddingTop: "1vw" }}
              />

              <Grid
                item
                xs={12}
                md={6}
                style={{ marginLeft: "0vw", marginLeft: "0vw" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ marginLeft: "1vw", marginRight: "1vw" }}
                      inputId="soloTransferencias"
                      checked={soloTransferencias ? soloTransferencias : false}
                      onChange={(e) => {
                        setSoloTransferencias(e.target.checked);
                      }}
                    />
                  }
                  label="Solo transferencias entre cuentas"
                  labelPlacement="start"
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={6}
                style={{ marginLeft: "0vw", marginLeft: "0vw" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ marginLeft: "1vw", marginRight: "1vw" }}
                      inputId="excluirTransferencias"
                      checked={
                        excluirTransferencias ? excluirTransferencias : false
                      }
                      onChange={(e) => {
                        setExcluirTransferencias(e.target.checked);
                      }}
                    />
                  }
                  label="Excluir transferencias entre cuentas"
                  labelPlacement="start"
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={12}
                style={{ paddingLeft: "1vw", marginTop: "1vw" }}
              >
                <label htmlFor="id">Empresas</label>

                <MultiSelect
                  value={selectedCities}
                  onChange={(e) => setSelectedCities(e.value)}
                  options={
                    empresas ? empresas.filter((item) => item.habilitado) : null
                  }
                  optionLabel="nombre"
                  placeholder="Seleccione las empresas"
                  maxSelectedLabels={10}
                  display="chip"
                  style={{ marginLeft: "1vw" }}
                  //className="w-full md:w-40rem"
                />
              </Grid>
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}
/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
